import React, { useState, useEffect, Fragment, useRef } from "react";
import { Button, Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { FormControl } from "@mui/material";
import { TextField } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import RichTextBoxTabPanel from "../../../components/RichTextBoxEditerTabs";
import { IRPTestCreate, IRPTestEdit, IRPTestPreview } from "../modal";
import {
  CreateIRPTestPreview,
  EditIRPTestPreview,
  getIRPTestTypes,
} from "../helper";
import { useIncidentResponsePlanContext } from "../../../context/IncidentResponsePlan/IncidentPlanResponceContext";
import { convertToUTC } from "../../../utils/ConvertDate";
import { useUserContext } from "../../../context/auth/UserContext";
import { useAccessRights } from "../../../utils/useAccessRights";
const initialFormState: IRPTestPreview = {
  testName: "",
  testType: { testTypeID: 0, testTypeName: "" },
  incidentDate: "",
  resolutionDate: "",
  description: "",
  detection: "",
  analysis: "",
  containment: "",
  eradication: "",
  recovery: "",
  lessonsLearned: "",
  partiesContacted: "",
};

export const IncidentResponseTestForm = () => {
  const navigate = useNavigate();
  const incidentResponseTestAccess = useAccessRights("Incident Response Tests");

  const location = useLocation();
  const { userId, companyProfileID } = useUserContext();
  const { IRPTestDetails } = useIncidentResponsePlanContext();

  const [formValues, setFormValues] = useState(initialFormState);
  const [isDisableCreate, setIsDisableCreate] = React.useState<boolean>(false);
  const [testTypeList, setTestTypeList] = useState<any[]>([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const isUpdatedRef = useRef(isUpdated);
  const [isUserStillOnPage, setIsUserStillOnPage] = useState(false);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });

  const handleCloseDialog = () => {
    setDialogState({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    });
    handleCancel();
  };

  const tabDetalis = [
    {
      label: "description",
      key: "description",
      id: `tab-description`,
      editerValue: formValues.description,
    },
    {
      label: "detection",
      key: "detection",
      id: `tab-detection`,
      editerValue: formValues.detection,
    },
    {
      label: "analysis",
      key: "analysis",
      id: `tab-analysis`,
      editerValue: formValues.analysis,
    },
    {
      label: "containment",
      key: "containment",
      id: `tab-containment`,
      editerValue: formValues.containment,
    },
    {
      label: "eradication",
      key: "eradication",
      id: `tab-eradication`,
      editerValue: formValues.eradication,
    },
    {
      label: "recovery",
      key: "recovery",
      id: `tab-recovery`,
      editerValue: formValues.recovery,
    },
    {
      label: "lessons learned",
      key: "lessonsLearned",
      id: `tab-lessonsLearned`,
      editerValue: formValues.lessonsLearned,
    },
    {
      label: "Parties Contacted",
      key: "partiesContacted",
      id: `tab-partiesContacted`,
      editerValue: formValues.partiesContacted,
    },
  ];

  const handleTabEditerChange = (val: any, key: any) => {
    handleFormChange({
      target: { value: val, id: key },
    });
  };

  const handleCancel = () => {
    navigate("/incident-response-test");
    setFormValues(initialFormState);
  };

  const handleFormChange = (e: { target: { id: any; value: any } }) => {
    const { id, value } = e.target;

    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: value,
    }));
  };

  const handleCreateTest = async () => {
    try {
      const date = new Date();

      const payload: IRPTestCreate[] = [
        {
          testName: formValues.testName,
          testType: formValues.testType?.testTypeID,
          incidentDate: convertToUTC(formValues.incidentDate),
          resolutionDate: convertToUTC(formValues.resolutionDate),
          description: formValues.description,
          detection: formValues.detection,
          analysis: formValues.analysis,
          containment: formValues.containment,
          eradication: formValues.eradication,
          recovery: formValues.recovery,
          lessonsLearned: formValues.lessonsLearned,
          partiesContacted: formValues.partiesContacted,
          createDate: date,
          createdBy: userId,
          companyProfileID: companyProfileID,
          isEditedByUserId: "0",
        },
      ];

      const res = await CreateIRPTestPreview(payload);

      if (res.succeeded === true) {
        setDialogState({
          title: "Success",
          body: "Test successfully created",
          action: "OK",
          actionCancel: "",
          openSuccessDialogBox: true,
          openDeleteConfirmationDialog: false,
        });
      } else {
        setDialogState({
          title: "Error",
          body: "Unexpected Error",
          action: "OK",
          actionCancel: "",
          openSuccessDialogBox: true,
          openDeleteConfirmationDialog: false,
        });
      }
    } finally {
      setFormValues(initialFormState);
    }
  };
  const handleEditTest = async () => {
    try {
      setIsUpdated(true);
      const date = new Date();

      const payload: IRPTestEdit[] = [
        {
          testID: IRPTestDetails.testID,
          testName: formValues.testName,
          testType: formValues.testType?.testTypeID,
          incidentDate: convertToUTC(formValues.incidentDate),
          resolutionDate: convertToUTC(formValues.resolutionDate),
          description: formValues.description,
          detection: formValues.detection,
          analysis: formValues.analysis,
          containment: formValues.containment,
          eradication: formValues.eradication,
          recovery: formValues.recovery,
          lessonsLearned: formValues.lessonsLearned,
          partiesContacted: formValues.partiesContacted,
          updateDate: date,
          updateBy: userId,
          companyProfileID: companyProfileID,
          isEditedByUserId: "0",
        },
      ];

      // console.log("handleEditTest payload",payload)
      const res = await EditIRPTestPreview(payload);
      if (res.succeeded === true) {
        setDialogState({
          title: "Success",
          body: "Test successfully updated",
          action: "OK",
          actionCancel: "",
          openSuccessDialogBox: true,
          openDeleteConfirmationDialog: false,
        });
      } else {
        setDialogState({
          title: "Error",
          body: "Unexpected Error",
          action: "OK",
          actionCancel: "",
          openSuccessDialogBox: true,
          openDeleteConfirmationDialog: false,
        });
      }
    } finally {
      setFormValues(initialFormState);
    }
  };

  const disableForm = () => {
    const {
      testName,
      incidentDate,
      resolutionDate,
      description,
      testType,
      detection,
      analysis,
      containment,
      eradication,
      recovery,
      lessonsLearned,
      partiesContacted,
    } = formValues;

    if (
      !testName ||
      !testType?.testTypeName ||
      !description ||
      !detection ||
      !analysis ||
      !containment ||
      !eradication ||
      !recovery ||
      !lessonsLearned ||
      !incidentDate ||
      !resolutionDate ||
      !partiesContacted
    ) {
      return true;
    }
    if (IRPTestDetails.testID) {
      return (
        testName === IRPTestDetails.testName &&
        testType?.testTypeID === IRPTestDetails.testType &&
        incidentDate === IRPTestDetails.incidentDate &&
        resolutionDate === IRPTestDetails.resolutionDate &&
        description === IRPTestDetails.description &&
        detection === IRPTestDetails.detection &&
        analysis === IRPTestDetails.analysis &&
        containment === IRPTestDetails.containment &&
        eradication === IRPTestDetails.eradication &&
        recovery === IRPTestDetails.recovery &&
        lessonsLearned === IRPTestDetails.lessonsLearned &&
        partiesContacted === IRPTestDetails.partiesContacted
      );
    }
  };
  const fetchTypes = async () => {
    const res = await getIRPTestTypes();
    setTestTypeList(res);
    if (IRPTestDetails.testID) {
      const findTestName = res
        .filter((test: any) => test.testTypeID == IRPTestDetails.testType)
        .map((name: { testTypeName: any }) => name.testTypeName);

      setFormValues({
        testName: IRPTestDetails.testName,
        testType: {
          testTypeID: IRPTestDetails?.testType,
          testTypeName: findTestName[0],
        },
        incidentDate: IRPTestDetails.incidentDate,
        resolutionDate: IRPTestDetails.resolutionDate,
        description: IRPTestDetails.description,
        detection: IRPTestDetails.detection,
        analysis: IRPTestDetails.analysis,
        containment: IRPTestDetails.containment,
        eradication: IRPTestDetails.eradication,
        recovery: IRPTestDetails.recovery,
        lessonsLearned: IRPTestDetails.lessonsLearned,
        partiesContacted: IRPTestDetails.partiesContacted,
      });
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  useEffect(() => {
    console.log("isUpdated", isUpdated);
    isUpdatedRef.current = isUpdated;
  }, [isUpdated]);

  const handleExit = async (isEdited: boolean) => {
    console.log("handleExit", isUpdatedRef.current);
    if (IRPTestDetails.testID && !isUpdatedRef.current) {
      const date = new Date();
      const payload = [
        {
          ...IRPTestDetails,
          isEditedByUser: isEdited,
          isEditedByUserId: userId + "",
          updateBy: userId,
          updateDate: date,
        },
      ];
      try {
        const resUpdate = await EditIRPTestPreview(payload);
        console.log("handleExit resUpdate", resUpdate);
        if (resUpdate) {
          setIsUserStillOnPage(false);
          return resUpdate;
        }
      } catch (error) {
        console.log("@@Error", error);
      }
    }
  };

  useEffect(() => {
    return () => {
      handleExit(false);
    };
  }, [location]);

  useEffect(() => {
    console.log("isUserStillOnPage >> ", isUserStillOnPage);
    if (isUserStillOnPage) {
      handleExit(true);
    }
  }, [isUserStillOnPage]);

  useEffect(() => {
    console.log("beforeunload");

    const handleBeforeUnload = async (event: BeforeUnloadEvent) => {
      console.log("handleBeforeUnload", event);
      event.preventDefault();
      await handleExit(false);
      setIsUserStillOnPage(true);
      const message =
        "You have unsaved changes. Are you sure you want to leave? ";
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <Fragment>
      <Grid
        container
        justifyContent="center"
        sx={{
          height: "100%",
          width: "100%",
          padding: "1rem",
          margin: "1rem 0",
          background: "#FFF",
          borderRadius: "2%",
        }}
      >
        <Grid xs={12}>
          <h3 style={{ fontWeight: "400", margin: "0.5rem 0" }}>
            {/* {policyFormTitle} */}
            {IRPTestDetails.testID
              ? "Edit Incident Response Test"
              : "Create Incident Response Test"}
          </h3>
        </Grid>

        <Grid container spacing={2} sx={{ height: "100%", width: "90%" }}>
          <Grid xs={6}>
            <h4
              style={{
                color: "lightgrey",
                fontWeight: "400",
                fontStyle: "italic",
                margin: "0.5rem 0",
              }}
            >
              Test Name
            </h4>
            <TextField
              fullWidth
              variant="filled"
              size="small"
              id="testName"
              value={formValues.testName}
              onChange={handleFormChange}
            />
          </Grid>

          <Grid xs={6}>
            <h4
              style={{
                color: "lightgrey",
                fontWeight: "400",
                fontStyle: "italic",
                margin: "0.5rem 0",
              }}
            >
              Test Type
            </h4>
            <FormControl variant="filled" sx={{ minWidth: 200, width: "100%" }}>
              <Select
                id="testType"
                value={formValues.testType?.testTypeID || ""}
                onChange={(e) => {
                  const selectedTestType = testTypeList.find(
                    (type) => type.testTypeID === e.target.value
                  );
                  handleFormChange({
                    target: {
                      value: {
                        testTypeID: selectedTestType?.testTypeID,
                        testTypeName: selectedTestType?.testTypeName,
                      },
                      id: "testType",
                    },
                  });
                }}
              >
                {testTypeList.map((testType) => (
                  <MenuItem
                    key={testType.testTypeID}
                    value={testType.testTypeID}
                  >
                    {testType.testTypeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid xs={6}>
            <h4
              style={{
                color: "lightgrey",
                fontWeight: "400",
                fontStyle: "italic",
                margin: "0.5rem 0",
              }}
            >
              Incident Date
            </h4>
            <DatePicker
              value={
                formValues.incidentDate ? dayjs(formValues.incidentDate) : null
              } // Convert string to Dayjs
              onChange={(val: Dayjs | null) =>
                handleFormChange({
                  target: {
                    value: val ? val.toISOString() : "",
                    id: "incidentDate",
                  }, // Convert Dayjs to string
                })
              }
              slotProps={{ field: { clearable: true } }}
            />
          </Grid>

          <Grid xs={6}>
            <h4
              style={{
                color: "lightgrey",
                fontWeight: "400",
                fontStyle: "italic",
                margin: "0.5rem 0",
              }}
            >
              Resolution Date
            </h4>
            <DatePicker
              value={
                formValues.resolutionDate
                  ? dayjs(formValues.resolutionDate)
                  : null
              } // Convert string to Dayjs
              onChange={(val: Dayjs | null) =>
                handleFormChange({
                  target: {
                    value: val ? val.toISOString() : "",
                    id: "resolutionDate",
                  }, // Convert Dayjs to string
                })
              }
              slotProps={{ field: { clearable: true } }}
            />
          </Grid>

          <Grid xs={12}>
            <RichTextBoxTabPanel
              tabs={tabDetalis}
              handleTabEditerChange={handleTabEditerChange}
              readonly={false}
            />
          </Grid>

          <Grid xs={12} container justifyContent="end">
            <Button
              sx={{ p: 1, m: 1 }}
              variant="outlined"
              size="small"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            {IRPTestDetails.testID ? (
              <Button
                sx={{ p: 1, m: 1 }}
                variant="contained"
                size="small"
                onClick={handleEditTest}
                disabled={
                  disableForm() || !incidentResponseTestAccess?.isUpdate
                }
              >
                Edit
              </Button>
            ) : (
              <Button
                sx={{ p: 1, m: 1 }}
                variant="contained"
                size="small"
                onClick={handleCreateTest}
                disabled={
                  disableForm() || !incidentResponseTestAccess?.isCreate
                }
              >
                CREATE
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>

      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
